import React from 'react';
import { MailIcon, SunIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-ink-800 bg-ink-950 py-14" data-id="element-106" data-mp="3gezf99jl213s">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-107" data-mp="3gh3rcermy6f5">
        <div className="grid gap-8 sm:grid-cols-[1.4fr_1fr]" data-id="element-108" data-mp="32p5kybpb6omo">
          <div data-id="element-109" data-mp="36oxzd51dvozy">
            <p className="flex items-center gap-2 font-display text-lg font-900 uppercase tracking-wide text-white" data-id="element-110" data-mp="36oo5h6d7wxoz">
              <SunIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-111" data-mp="3ugbpd4c2b8hr" />
              El Código Solar 360°
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400" style={{
            fontSize: "28px"
          }} data-id="element-112" data-mp="36mtcl0px0t0">
              Cero técnica requerida--Garantía 7 días--$17USD.
            </p>
          </div>
          <div className="sm:text-right" data-id="element-113" data-mp="3qfjfc8vd8zkf">
            <a href="mailto:soporte@codigosolar360.com" className="inline-flex items-center gap-2 text-sm text-slate-300 transition-colors duration-150 ease-smooth hover:text-gold" data-id="element-114" data-mp="29yxdpewb9omv">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-115" data-mp="3l9abhd1s8u1s" />
              soporte@kodadigital.shop
            </a>
          </div>
        </div>

        <p className="mt-10 border-t border-ink-800 pt-6 text-xs leading-relaxed text-slate-500" data-id="element-116" data-mp="3gca5f24xnrao">
          © El Código Solar 360° 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
        <p className="mt-4 font-display text-sm font-600 italic text-gold" data-id="element-117" data-mp="828mc4dy418m">
          “El sol ya está produciendo. La pregunta es si estás aprovechándolo.”
        </p>
      </div>
    </footer>;
}